exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "li.col-item[data-v-21d60ae4]{list-style:none}li.col-item span.col-span-title[data-v-21d60ae4]{display:inline-block;font-size:13px;width:120px}li.col-item .col-delete-button[data-v-21d60ae4]{margin-left:6px}.panes-setting ul[data-v-21d60ae4]{-webkit-padding-start:0;padding-inline-start:0;padding-left:0;margin:0}.panes-setting .drag-option[data-v-21d60ae4]{cursor:move}.panes-setting li.ghost[data-v-21d60ae4]{background:#fff;border:2px dotted #409eff}\n", ""]);

// exports
